import {IRunFile} from '../../incase-domain/proptypes/runfile';
import {AppState} from '../reducer';

const EMPTY_OBJECT = {};
const EMPTY_ARRAY: never[] = [];

export const runFileSelector = (state: AppState): IRunFile => state.runFileReducer.runFile;
export const runFileIdSelector = (state: AppState): string => state.runFileReducer.runFile._id || '';
export const runFilePresentationIdSelector = (state: AppState): string => state.runFileReducer.runFile.presentationId || '';
export const runFileUserIdSelector = (state: AppState): string => state.runFileReducer.runFile.userId || '';
export const runFileGroupIdentificationSelector = (state: AppState): string => state.runFileReducer.runFile.groupIdentification || '';
export const runFileTimeElapsedSelector = (state: AppState): number => state.runFileReducer.runFile.timeElapsed || 0;
export const runFileCustomVarsOnlySelector = (state: AppState): IRunFile =>
    ({
        customVars: state.runFileReducer.runFile.customVars || EMPTY_OBJECT,
    } as IRunFile);
export const pointsSelector = (state: AppState): number => state.runFileReducer.runFile.points || 0;
export const runFileElementInteractionsSelector = (state: AppState): IRunFile['elementInteractions'] =>
    state.runFileReducer.runFile.elementInteractions || EMPTY_OBJECT;
export const runFileSlideDrawLinesSelector = (state: AppState): IRunFile['slideDrawLines'] =>
    state.runFileReducer.runFile.slideDrawLines || EMPTY_ARRAY;
export const runFileChalkboardUserCommentsSelector = (state: AppState): IRunFile['chalkboardUserComments'] =>
    state.runFileReducer.runFile.chalkboardUserComments || EMPTY_ARRAY;
export const runFileWatchedSlideIdsSelector = (state: AppState): IRunFile['watchedSlideIds'] =>
    state.runFileReducer.runFile.watchedSlideIds || EMPTY_ARRAY;
export const runFileCustomVarsSelector = (state: AppState): IRunFile['customVars'] =>
    state.runFileReducer.runFile.customVars || EMPTY_OBJECT;
